import LinkContract from './LinkContract';

export default LinkContract;
